export const PickSheetIcon = (props: { width?: string; height?: string; fill?: string }) => {
  const { width = "24px", height = "24px", fill = "#5C5F62" } = props;

  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 1.56 1.56"
      enableBackground="new 0 0 52 52"
    >
      <g>
        <path d="M0.729 1.095c0.021 0 0.042 0.003 0.06 0.009L0.465 0.186l-0.03 -0.09c-0.009 -0.027 -0.036 -0.039 -0.06 -0.03L0.093 0.159c-0.027 0.009 -0.039 0.036 -0.03 0.06l0.03 0.09c0.009 0.027 0.036 0.039 0.06 0.03L0.3 0.291l0.297 0.843c0.039 -0.024 0.084 -0.039 0.132 -0.039" />
        <path d="m1.236 0.876 -0.297 0.105c-0.03 0.012 -0.066 -0.006 -0.075 -0.036l-0.105 -0.297c-0.012 -0.03 0.006 -0.066 0.036 -0.075l0.297 -0.105c0.03 -0.012 0.066 0.006 0.075 0.036l0.105 0.297c0.012 0.03 -0.006 0.063 -0.036 0.075" />
        <path d="m0.954 0.387 -0.201 0.069c-0.03 0.012 -0.066 -0.006 -0.075 -0.036l-0.069 -0.201c-0.012 -0.03 0.006 -0.066 0.036 -0.075l0.201 -0.069c0.03 -0.012 0.066 0.006 0.075 0.036l0.069 0.201c0.012 0.027 -0.003 0.063 -0.036 0.075" />
        <path d="m1.497 1.065 -0.03 -0.09c-0.009 -0.027 -0.036 -0.039 -0.06 -0.03l-0.546 0.189c0.057 0.036 0.096 0.096 0.108 0.165L1.47 1.128c0.024 -0.009 0.036 -0.036 0.027 -0.063" />
        <path d="M0.729 1.173c-0.09 0 -0.165 0.075 -0.165 0.165s0.075 0.165 0.165 0.165 0.165 -0.075 0.165 -0.165c0 -0.093 -0.075 -0.165 -0.165 -0.165" />
      </g>
    </svg>
  );
};
